export const LangText: any = {
    us: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    ca: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    eu: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Product',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
    },
    uk: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Product',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
    },
    de: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Produkt',
        tab_support: 'Support',
        tab_specs: 'Technische Daten',
        btn_buy: 'Jetzt kaufen',
    },
    fr: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Produit',
        tab_support: 'Assistance',
        tab_specs: 'Spécifications',
        btn_buy: 'Acheter',
    },
    it: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Prodotto',
        tab_support: 'Assistenza',
        tab_specs: 'Specifiche',
        btn_buy: 'Acquista ora',
    },
    es: {
        product_name: 'EcoFlow TRAIL Series DC',
        tab_product: 'Producto',
        tab_support: 'Asistencia',
        tab_specs: 'Especificaciones',
        btn_buy: 'Comprar ahora',
    },
    nl: {
        product_name: 'EcoFlow TRAIL Serie DC',
        tab_product: 'Product',
        tab_support: 'Ondersteuning',
        tab_specs: 'Specificaties',
        btn_buy: 'Shop nu',
    },
};
